import React, { useId } from "react";
import "./HousingDevelopmentAdmin.css";

export default function AccessibleBarChart({ title, items = [], description = "" }) {
  const generatedId = useId().replace(/:/g, "");
  const titleId = `housing-chart-title-${generatedId}`;
  const descriptionId = `housing-chart-description-${generatedId}`;
  const maximum = Math.max(1, ...items.map((item) => Number(item.count) || 0));

  return (
    <figure
      className="hd-admin-chart"
      aria-labelledby={titleId}
      aria-describedby={description ? descriptionId : undefined}
    >
      <figcaption id={titleId}>{title}</figcaption>
      {description ? <p id={descriptionId} className="hd-admin-chart__description">{description}</p> : null}
      {items.length ? (
        <ul className="hd-admin-chart__list">
          {items.map((item) => {
            const count = Number(item.count) || 0;
            const percentage = Number.isFinite(Number(item.percentage))
              ? Number(item.percentage)
              : null;
            return (
              <li key={item.label}>
                <div className="hd-admin-chart__row">
                  <span>{item.label}</span>
                  <strong>
                    {count}
                    {percentage === null ? "" : ` (${percentage}%)`}
                  </strong>
                </div>
                <div className="hd-admin-chart__track" aria-hidden="true">
                  <span style={{ width: `${Math.max(2, Math.round((count / maximum) * 100))}%` }} />
                </div>
              </li>
            );
          })}
        </ul>
      ) : <p>No responses in this selection.</p>}
    </figure>
  );
}

